import React from 'react';
import PropTypes from 'prop-types';

const Alert = (props) => {
  return (
    <div className={`alert alert-${props.type}`}>
      {
        props.children ?? <span dangerouslySetInnerHTML={{ __html: props.text }} /> // eslint-disable-line react/no-danger
      }
    </div>
  );
};

Alert.propTypes = {
  children: PropTypes.node,
  text: PropTypes.string.isRequired,
  type: PropTypes.string,
};

Alert.defaultProps = {
  children: undefined,
  type: 'info',
};

export default Alert;
